import { useState, useCallback } from 'react';
import { activateUser } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useActivateUser({ onSuccess } = {}) {
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState(null);

  const clearError = useCallback(() => setError(null), []);

  const activate = useCallback(async (userId) => {
    setError(null);
    setLoadingId(userId);
    try {
      await activateUser(userId);
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      const msg = handleApiError(err);
      setError(msg);
    } finally {
      setLoadingId(null);
    }
  }, [onSuccess]);

  return { activate, loadingId, error, clearError };
}


